export default {"src":"/_next/static/media/case.652b88bb.svg","height":23,"width":23,"blurWidth":0,"blurHeight":0};